import ClientRateMenuGridLegacy from "../clientadmin/ClientRateMenuGridLegacy";

const ClientPlanLibraryLegacy = () => {
  return (
    <div style={{ marginTop: "20px" }}>
      {/* <h2>Plan Library</h2> */}
      <ClientRateMenuGridLegacy />
    </div>
  );
};

export default ClientPlanLibraryLegacy;
